import React from 'react';
import { View } from 'react-navi';
import ReactGA from 'react-ga';
import { mount, compose, withView, route as naviRoute } from 'navi';
import { Block, Prize } from '@contest-web/components/src/components';
import IndexApp from './IndexApp';
import PrivacyApp from './PrivacyApp';
import EntriesApp from './EntriesApp';
import ProfileApp from './ProfileApp';
import { EntriesRepository } from '../repositories/entries';
import profiles from './profiles';
import Tvasahi from './news/tvasahi';
import KobeCollection from './news/kobecollection';
import AgeStock from './news/agestock';
import RizeClinic from './news/rizeclinic';
import RizeFinal from './news/rizefinal';
import Presenter from "./news/presenter";
import Faq from "./news/faq";

const fromPairs = require('lodash.frompairs');

export default compose(
  withView((request: any, context: any) => {
    if (process.env.REACT_APP_ANALYTICS_ENABLED === 'true') {
      console.log('[pageview]', request.path);
      ReactGA.pageview(request.path);
    }
    return <View />;
  }),
  mount({
    '/': naviRoute({
      title: process.env.REACT_APP_WEBSITE_NAME,
      getView: () => IndexApp,
    }),
    '/top': naviRoute({
      title: process.env.REACT_APP_WEBSITE_NAME,
      getView: () => IndexApp,
    }),
    '/profile': mount({
      ...fromPairs(profiles.map(profile => [`/${profile.id}`, profile.getPage])),
    }),
    '/news/2019-08-07-tvasahi': naviRoute({
      title: `8/7（水）MISS/MR COLLECTION 2019 in テレ朝夏祭りに候補者が参加しました | ${
        process.env.REACT_APP_WEBSITE_NAME
      }`,
      getView: () => Tvasahi,
    }),
    '/news/2019-09-08-kobecollection': naviRoute({
      title: `9/8(日) 神戸コレクション 2019 AUTUMN/WINTER -ガールズフェスティバル-「SHOWROOM SPECIALSTAGE」にて、モデルとしてミスサークル候補者が登場しました | ${
        process.env.REACT_APP_WEBSITE_NAME
      }`,
      getView: () => KobeCollection,
    }),
    '/news/2019-10-04': naviRoute({
      title: `「MISS CIRCLE CONTEST2019 supported by リゼクリニック ・メンズリゼ」表彰式開催決定！ | ${
        process.env.REACT_APP_WEBSITE_NAME
      }`,
      getView: () => AgeStock,
    }),
    '/news/2019-10-15': naviRoute({
      title: `セミファイナル 特別協賛審査 詳細決定
 | ${process.env.REACT_APP_WEBSITE_NAME}`,
      getView: () => RizeClinic,
    }),
    '/news/2019-10-29': naviRoute({
      title: `ファイナル 特別協賛審査 詳細決定
 | ${process.env.REACT_APP_WEBSITE_NAME}`,
      getView: () => RizeFinal,
    }),

    '/news/2019-11-11': naviRoute({
      title: `スペシャルプレゼンターとして昨年度グランプリ「平館真生」さんの出演が決定致しました。
 | ${process.env.REACT_APP_WEBSITE_NAME}`,
      getView: () => Presenter,
    }),
    '/news/2019-11-11-faq': naviRoute({
      title: `【表彰式】注意事項・よくある質問
 | ${process.env.REACT_APP_WEBSITE_NAME}`,
      getView: () => Faq,
    }),
    '/first': naviRoute({
      title: `1次審査通過者一覧 | ${process.env.REACT_APP_WEBSITE_NAME}`,
      getView: async () => {
        const list = await EntriesRepository.getEntries({ prize: Prize.first });
        return (
          <EntriesApp
            modalTitle="1次審査通過者"
            title={
              <>
                <h1 className="title is-spaced has-text-centered">
                  1次審査通過者一覧
                </h1>
              </>
            }
            list={list}
          />
        );
      },
    }),
    '/second': naviRoute({
      title: `2次審査通過者一覧 | ${process.env.REACT_APP_WEBSITE_NAME}`,
      getView: async request => {
        const list = await EntriesRepository.getEntries({ prize: Prize.second });
        const { entry: id } = request.params;
        if (id) {
          const [entry, profile, prize] = await Promise.all([
            EntriesRepository.getEntry(id, { prize: Prize.second }),
            EntriesRepository.getProfile(id),
            EntriesRepository.getMaxPrize(id),
          ]);
          if (entry) {
            return <ProfileApp entry={entry} profile={profile || {}} prize={prize} />;
          }
        }
        return (
          <EntriesApp
            isSummary
            modalTitle="2次審査通過者一覧"
            title={
              <>
                <h1 className="title is-spaced has-text-centered">2次審査通過者一覧</h1>
              </>
            }
            list={list}
          />
        );
      },
    }),
    '/third': naviRoute({
      title: `4次審査 | ${process.env.REACT_APP_WEBSITE_NAME}`,
      getView: async request => {
        const list = await EntriesRepository.getEntries({ prize: Prize.third });
        const { entry: id } = request.params;
        if (id) {
          const [entry, profile, prize] = await Promise.all([
            EntriesRepository.getEntry(id, { prize: Prize.third }),
            EntriesRepository.getProfile(id),
            EntriesRepository.getMaxPrize(id),
          ]);
          if (entry) {
            return <ProfileApp entry={entry} profile={profile || {}} prize={prize} />;
          }
        }
        return (
          <EntriesApp
            isSummary
            modalTitle="4次審査"
            title={
              <>
                <h1 className="title is-spaced has-text-centered">4次審査</h1>
                <div className="has-text-centered is-margin-bottom-0-5 is-flex is-flex-direction-column">
                  <p className="is-margin-bottom-0-5">
                    <span className="tag has-text-weight-bold is-warning">※ 4次審査通過者は10月3日発表予定です</span>
                  </p>
                </div>
                <div className="has-text-centered is-margin-bottom-0-5 is-flex is-flex-direction-column">
                  <p className="is-margin-bottom-0-5">
                    <span className="tag is-rounded has-text-weight-bold">WEB審査</span>
                  </p>
                  <p className="is-size-7">
                    <span>9月4日12:00〜9月29日21:59</span>
                  </p>
                </div>
                <div className="has-text-centered is-margin-bottom-0-5 is-flex is-flex-direction-column">
                  <p className="is-margin-bottom-0-5">
                    <span className="tag is-rounded has-text-weight-bold">SHOWROOM審査</span>
                  </p>
                  <p className="is-size-7">
                    <span>予選 9月4日12:00〜9月6日21:59</span>
                  </p>
                  <p className="is-size-7">
                    <span>準決勝 9月13日12:00〜9月15日21:59</span>
                  </p>
                  <p className="is-size-7">
                    <span>決勝 9月20日12:00〜9月29日21:59</span>
                  </p>
                </div>
                <div className="has-text-centered is-margin-bottom-0-5 is-flex is-flex-direction-column">
                  <p className="is-margin-bottom-0-5">
                    <span className="tag is-rounded has-text-weight-bold">mysta審査</span>
                  </p>
                  <p className="is-size-7">
                    <span>9月16日20:00〜9月29日21:59</span>
                  </p>
                </div>
              </>
            }
            list={list}
          />
        );
      },
    }),
    '/semifinal': naviRoute({
      title: `セミファイナル | ${process.env.REACT_APP_WEBSITE_NAME}`,
      getView: async request => {
        const list = await EntriesRepository.getEntries({ prize: Prize.semifinal });
        const { entry: id } = request.params;
        if (id) {
          const [entry, profile, prize] = await Promise.all([
            EntriesRepository.getEntry(id, { prize: Prize.semifinal }),
            EntriesRepository.getProfile(id),
            EntriesRepository.getMaxPrize(id),
          ]);
          if (entry) {
            return <ProfileApp entry={entry} profile={profile || {}} prize={prize} />;
          }
        }
        return (
          <EntriesApp
            isSummary
            modalTitle="セミファイナル"
            title={
              <>
                <h1 className="title is-spaced has-text-centered">セミファイナル</h1>
                <div className="has-text-centered is-margin-bottom-0-5 is-flex is-flex-direction-column">
                  <p className="is-margin-bottom-0-5">
                    <span className="tag is-rounded has-text-weight-bold">WEB審査</span>
                  </p>
                  <p className="is-size-7">
                    <span>10月7日12:00〜10月20日21:59</span>
                  </p>
                </div>
                <div className="has-text-centered is-margin-bottom-0-5 is-flex is-flex-direction-column">
                  <p className="is-margin-bottom-0-5">
                    <span className="tag is-rounded has-text-weight-bold">mysta審査</span>
                  </p>
                  <p className="is-size-7">
                    <span>10月11日20:00〜10月20日21:59</span>
                  </p>
                </div>
                <div className="has-text-centered is-margin-bottom-0-5 is-flex is-flex-direction-column">
                  <p className="is-margin-bottom-0-5">
                    <span className="tag is-rounded has-text-weight-bold">特別協賛審査</span>
                  </p>
                  <p className="is-size-7">
                    <span>10月16日11:00～10月20日23:59</span>
                    <br />
                    <a className="has-text-white has-text-underline" href="/news/2019-10-15">
                      詳細はこちら
                    </a>
                  </p>
                </div>
              </>
            }
            list={list}
          />
        );
      },
    }),
    '/final': naviRoute({
      title: `ファイナル | ${process.env.REACT_APP_WEBSITE_NAME}`,
      getView: async request => {
        const list = await EntriesRepository.getEntries({ prize: Prize.final });
        const { entry: id } = request.params;
        if (id) {
          const [entry, profile, prize] = await Promise.all([
            EntriesRepository.getEntry(id, { prize: Prize.final }),
            EntriesRepository.getProfile(id),
            EntriesRepository.getMaxPrize(id),
          ]);
          if (entry) {
            return <ProfileApp entry={entry} profile={profile || {}} prize={prize} />;
          }
        }
        return (
          <EntriesApp
            isFinal
            isSummary
            modalTitle="ファイナル審査"
            url={"https://www.rizeclinic.com/missmrcampus2019/misscircle-vote"}
            title={
              <>
                <h1 className="title is-spaced has-text-centered">ファイナル審査</h1>
                <div className="has-text-centered is-margin-bottom-0-5 is-flex is-flex-direction-column">
                  <p className="is-margin-bottom-0-5">
                    <span className="tag is-rounded has-text-weight-bold">WEB審査</span>
                  </p>
                  <p className="is-size-7">
                    <span>10月29日19:00〜11月10日21:59</span>
                  </p>
                </div>
                <div className="has-text-centered is-margin-bottom-0-5 is-flex is-flex-direction-column">
                  <p className="is-margin-bottom-0-5">
                    <span className="tag is-rounded has-text-weight-bold">SHOWROOM審査</span>
                  </p>
                  <p className="is-size-7">
                    <span>11月2日20:00〜11月10日21:59</span>
                  </p>
                </div>
                <div className="has-text-centered is-margin-bottom-0-5 is-flex is-flex-direction-column">
                  <p className="is-margin-bottom-0-5">
                    <span className="tag is-rounded has-text-weight-bold">mysta審査</span>
                  </p>
                  <p className="is-size-7">
                    <span>11月4日20:00〜11月10日21:59</span>
                  </p>
                </div>
                <div className="has-text-centered is-margin-bottom-0-5 is-flex is-flex-direction-column">
                  <p className="is-margin-bottom-0-5">
                    <span className="tag is-rounded has-text-weight-bold">特別協賛審査</span>
                  </p>
                  <p className="is-size-7">
                      <a className="has-text-white has-text-underline" href="/news/2019-10-29">
                          詳細はこちら
                      </a>
                  </p>
                </div>
              </>
            }
            list={list}
          />
        );
      },
    }),
    '/privacy': naviRoute({
      title: `プライバシーポリシー |  ${process.env.REACT_APP_WEBSITE_NAME}`,
      getView: () => PrivacyApp,
    }),
  }),
);
